import { useMutation } from 'react-query';
import { MutationConfig, queryClient } from 'src/lib/react-query';
import useNotification from 'src/store/Notifications/useNotification';
import { axiosDefaultApi } from 'src/lib/axios';


export const createPhonecentersMaintenance = ( {data} : {data: IPostNewPhonecentersMaintenance | {}}): Promise<string> => {
  return axiosDefaultApi.post(`/api/PhonecentersMaintenance/InsertPhonecentersMaintenance`, data);
};

type QueryFnType = typeof createPhonecentersMaintenance;

type UseCreatePhonecentersMaintenanceOptions = {
  data: IPostNewPhonecentersMaintenance | {};
  config?: MutationConfig<QueryFnType>;
};

export const useCreatePhonecentersMaintenance = ({ config }: UseCreatePhonecentersMaintenanceOptions) => {
    const {addNotification, setIsNotificationVisible} = useNotification();
    return useMutation({
        onError: (error: any) => {
            addNotification(`Υπήρξε κάποιο πρόβλημα στην δημιουργία του Συντηρητή.`, 500);
            console.error('Couldnt create new PhonecentersMaintenance', error);
            setIsNotificationVisible(true)
          },
          onSuccess: () => {
            queryClient.invalidateQueries(["getAllPhonecentersMaintenances"])
            addNotification("Δημιουργήθηκε Νέος Συντηρητής.", 200);
            setIsNotificationVisible(true)
            
          },
        ...config,
        mutationFn: createPhonecentersMaintenance,
    })
}